/*
    CAUTION: PLEASE READ! This File was auto generated by the system.
    Any changes you make will be removed the next time it's generated.
*/
 import { ItemService } from 'spark-core-dx/services'

export const Operations = {
  AIPromptItem : {
     ExecuteAIPrompt: "ExecuteAIPrompt",
  },
  AILevelProfileItem : {
  },
  ExternalSystemItem : {
     ExternalSystemCheck: "ExternalSystemCheck",
     ExternalSystemValidate: "ExternalSystemValidate",
     ExternalSystemPreview: "ExternalSystemPreview",
     ExternalSystemSync: "ExternalSystemSync",
     ExternalSystemDiscoverDirty: "ExternalSystemDiscoverDirty",
  },
  MigrationProjectItem : {
     AIMigrationAnalyze: "AIMigrationAnalyze",
     AIMigrationRunAnalysis: "AIMigrationRunAnalysis",
  },
  EntityMasterRecordItem : {
     FullMasterRecord: "FullMasterRecord",
     LookupMasterEntityObject: "LookupMasterEntityObject",
  },
  EntityObjectItem : {
     LoadEntityFields: "LoadEntityFields",
     EntityObjectFieldMapping: "EntityObjectFieldMapping",
     MapEntityObject: "MapEntityObject",
     SearchEntityObject: "SearchEntityObject",
  },
  RemoteBatchHostItem : {
     CheckRemoteBatchHostStatus: "CheckRemoteBatchHostStatus",
     StartRemoteBatchHost: "StartRemoteBatchHost",
     DrainRemoteBatchHost: "DrainRemoteBatchHost",
     StopRemoteBatchHost: "StopRemoteBatchHost",
     RestartRemoteBatchHost: "RestartRemoteBatchHost",
     RunRemoteBatchHostManualTest: "RunRemoteBatchHostManualTest",
  },
  APIEndpointBatchHostItem : {
     CheckAPIEndpointBatchHostStatus: "CheckAPIEndpointBatchHostStatus",
     StartAPIEndpointBatchHost: "StartAPIEndpointBatchHost",
     StopAPIEndpointBatchHost: "StopAPIEndpointBatchHost",
  },
  SourceObjectItem : {
     LoadSourceObjectKeys: "LoadSourceObjectKeys",
     SearchSourceObject: "SearchSourceObject",
  },
  SourceSystemItem : {
     LoadSourceObjects: "LoadSourceObjects",
     LoadSourceSystemTargets: "LoadSourceSystemTargets",
  },
  WarehouseItem : {
     WarehouseDeploy: "WarehouseDeploy",
     WarehouseDrop: "WarehouseDrop",
     WarehouseSync: "WarehouseSync",
     WarehouseUpgrade: "WarehouseUpgrade",
     WarehouseCheck: "WarehouseCheck",
     WarehouseRecordCheck: "WarehouseRecordCheck",
     FullWarehouseLoadProcess: "FullWarehouseLoadProcess",
  },
  AIChatSessionItem : {
     QuestionSourceSystems: "QuestionSourceSystems",
  },
  AIChatStepItem : {
  },
}

export class ExternalAppItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalApp", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ExternalAppSettingItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalAppSetting", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ExternalSystemItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalSystem", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ExternalSystemDirtyRecordItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalSystemDirtyRecord", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ExternalSystemDirtyScanStateItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalSystemDirtyScanState", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class MigrationProjectItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/MigrationProject", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIPromptItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIPrompt", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AILevelProfileItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AILevelProfile", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ConvokeAppConfigItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ConvokeAppConfig", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataTypeItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataType", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityMasterRecordItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityMasterRecord", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityMasterRecordMapItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityMasterRecordMap", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityObjectFieldMapItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityObjectFieldMap", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityObjectItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityObject", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityQueryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityQuery", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SchemaItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Schema", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class IntegrationItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Integration", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class RemoteBatchHostItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/RemoteBatchHost", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class APIEndpointBatchHostItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/APIEndpointBatchHost", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class BatchManagementPreferenceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/BatchManagementPreference", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ClientBillingProfileItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientBillingProfile", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SourceObjectItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SourceObject", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SourceQueryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SourceQuery", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SourceObjectRecordItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SourceObjectRecord", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SourceSystemItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SourceSystem", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EdiUsageLedgerItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EdiUsageLedger", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class TransformScriptItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/TransformScript", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DirtyRecordDeploymentItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DirtyRecordDeployment", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SchemaAPIItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SchemaAPI", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SchemaDestinationLogItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SchemaDestinationLog", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class WarehouseItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Warehouse", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIAnalyticsItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIAnalytics", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIChatItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIChat", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIChatSessionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIChatSession", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIChatStepItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIChatStep", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SageCustomerItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SageCustomer", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class SageVendorItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SageVendor", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class FileStorageItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/FileStorage", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataModelItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataModel", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataQueryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataQuery", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataModelWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataModelWorkspace", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataModelWorkspaceArtifactVersionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataModelWorkspaceArtifactVersion", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataModelWorkspaceBuildRunItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataModelWorkspaceBuildRun", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class UserDashboardWorkspaceStateItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/UserDashboardWorkspaceState", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}
